// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Lang from 'vue-lang'
import Cookies from 'vue-cookies'
import VueMoment from 'vue-moment'
import vClickOutside from 'v-click-outside'
import BackToTop from 'vue-backtotop'
import CheckboxRadio from 'vue-checkbox-radio'

// declare language files
const locales = {
  'en': require('./assets/data/locals_en.json'),
  'pl': require('./assets/data/locals_pl.json')
}

//default language
Vue.use(Lang, {lang: 'pl', locales: locales})

Vue.use(Cookies)
Vue.use(VueMoment);
Vue.config.productionTip = false

Vue.use(vClickOutside)
Vue.use(BackToTop)
Vue.use(CheckboxRadio)

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js